module.exports = __webpack_public_path__ + "img/Dont_Busy_backgrounds.9ceaae77.png";